export const widgetStaticSearchIndex = [
	{
		section: 'widgets',
		title: 'Introduction',
		path: '/widgets',
		summary: `The VoiceStorm JavaScript SDK includes a set of reusable widgets to help you quickly build a website showing VoiceStorm content.
The widgets use the JavaScript SDK API to get data, and use jQuery to add HTML markup to your page.
jQuery version 1.8.3 or higher included on your page initialized.
used to display posts, create posts, show leaderboards, edit user profile.
generates simple semantic HTML easily styled CSS match look feel your site.
generated headlines data-voicestorm-widget`,
		fields: 'data data- gertie epcot liberty snack'
	},
	{
		section: 'widgets',
		title: 'How Widgets Work',
		path: '/widgets/how',
		summary: `You can use the VoiceStorm JavaScript SDK widgets in several ways.
easiest way add data- attributes your markup.
customize your widget without JavaScript.
special requirements need to defer rendering programmatically initialize
only attribute required data-voicestorm-widget
instructs render inside element
Any content you provide body replaced
UserPosts
Programmatic API
flexible alternative jQuery plugin namespace attached to DOM element syntax
name VoiceStorm[Widget Name] Titles VoiceStormTitles
VoiceStormAsyncInit() postSummaries stream Showcase
Construction
created passing optional options object
ProfilePhoto VoiceStormProfilePhoto
stream VoiceStormStream take Showcase
Methods
method calls refresh set get a single option reload itself using current data
option(name)
option(name, value)
first parameter
grab underlying JavaScript
titles.option`,
		fields: 'data data- name skip take'
	},
	{
		section: 'widgets',
		title: 'Customization',
		path: '/widgets/customize',
		summary: `Each widget can be customized in a number of ways
data shown inside via options
Some widgets allow their behavior event handlers
look of your widgets CSS
way looks behaves page dramatically changed handlers
attributes specify form data-voicestorm-[option]
programmatically two ways customizing created pass anonymous object contains
After keyword get set jQuery plugin lists all its available options
data-voicestorm-widget stream data-voicestorm-take data-voicestorm-stream Showcase
data-voicestorm-postLinkFormat
initialization anonymous object
VoiceStormTitles FacebookFeed
Get value var include $ titles
Date and Time Format Strings
display date and/or time specified using format string
This string contain static text along with date and time tokens components within
Localized Time Based on user's locale US standard shown example
LT
LTS	8:30:25 PM, 20:30:25
l	6/15/1986, 2009/6/15
ll	Jun 15 2009, 15 Juni 2009
L
LL
Month
M
MM	01 02 11 12
MMM	Jan Feb Nov Dec
MMMM	January February November December
Day of Month
D	1 2 30 31
DD
Day of Week
ddd	Sun Mon Fri Sat
dddd	Sunday Monday Friday Saturday
Year
YY	70 71 29 30
YYYY	1970 1971 2029 2030
Hour
H	0
HH	00 01
hh
AM/PM
AM PM
Minute
m	58 59
mm	58 59
Second
s
ss
Time Zone Offset
Z	-07:00 -06:00 +06:00 +07:00
ISO 8601 – UTC or Local based on timezoneOffset
I	2013-09-20T00:20:23Z
i	2013-09-19T19:20:23-05:00
Including Literal Text
inside square brackets sequence
$date Sent M/D/YYYY Renders Sent on 4/14/2014
Date and Time Callback
accept callback function datetimeRenderer allowing you to fine tune how represented four arguments
date ISO8601 end letter Z Example 2014-04-11T17:14:49.9263490Z
dateFormat
user VoiceStorm.currentUser timeZone
currentTime elapsed between now
global variables community manager:
VoiceStorm.defaults.timezoneIanaName tz database IANA America/Los_Angeles
VoiceStorm.defaults.timezoneOffset designator -08:00
myDateTimeRenderer Moment Timezone
Image Sizes
variety pre-scaled image sizes differ by type
Post Image Sizes
None
Original Full size
Box1280 Scaled down to fit within a 1280x1280 box
Box960 960x960
Box640 640x640
Box320 320x320
Box100 100x100
Box80 80x80
Box40 40x40
Square320 Scaled centered cropped completely fill an 320x320
Square240 240x240
Square80 80x80
User Profile Picture Sizes
Square60 60x60
Square40 40x40
Square20 20x20
Global Options
Rather than setting individual widget globally defaults property
Shows 20 articles VoiceStorm.defaults.take VoiceStormAsyncInit
VoiceStorm.defaults.postLinkFormat slug
Note
Events
custom events most actions
Generally come infinitive past participle form render triggered start rendered triggered completion action
namespaced form event.voicestorm.widget
adding event listener DOM element which
inbox-conversations on rendered.voicestorm.conversations
Submit Events
submit data ProfilePublic pair submit submitted submit.voicestorm.profilepublic fired before perform validation pre-submit visualization
cancel submission call preventDefault handler
submit.voicestorm.profilepublic event.preventDefault
submitted response received from server reset show notification update user interface success failure indicator
indicates updated`,
		fields: 'data data- voicestorm defaults take postLinkFormat stream'
	},
	{
		section: 'widgets',
		title: 'Styling',
		path: '/widgets/style',
		summary: `VoiceStorm JavaScript SDK widgets add HTML to your page.
They are designed using simple, semantic tags and class names, where needed, to allow you highly customize way they look page.
Each widget wrapped div element with class name form voicestorm-[widgetname]-widget
This allows target specific CSS
Without additional styling Titles generates simple HTML looks
no styling applied
Applying styles make it like`,
		fields: 'data data- gertie epcot liberty snack wine'
	},
]


// WEBPACK FOOTER //
// ./src/constants/widgetStaticSearchIndex.js